import React from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'antd';
import $$ from 'cmn-utils';
import {utils_tool} from '../../../tool'
let {Storage} = utils_tool
 
class BaseComponent extends React.Component {
  /**
   * 在没有dispatch函数时，如果想要在组件内进行跳转可以用router进行跳转
   */
  static contextTypes = {
    router: PropTypes.object
  };


  /**
   * history api 路由跳转
   */
  get history() {
    return this.context.router.history;
  }

  /**
   * 处理用户后的业务
   * 需要子类重写 
   * on_complete_by_davy 2019-5-14
   */
  handleUserService() {
  }

  componentWillMount() {
    if (this._componentWillMount) {
      this._componentWillMount();
    }
  }

  componentDidMount() {
    this.isUserLogin();
    if (this._componentDidMount) {
      this._componentDidMount();
    }
  }

  componentDidUpdate() {
    if (this._componentDidUpdate) {
      this._componentDidUpdate();
    }
  }

  shouldComponentUpdate(nextProps, nextState) {
    if (this._shouldComponentUpdate) {
      return this._shouldComponentUpdate(nextProps, nextState);
    }
    return true;
  }

  componentWillUpdate(nextProps, nextState) {
    if (this._componentWillUpdate) {
      this._componentWillUpdate(nextProps, nextState);
    }
  }

  componentWillReceiveProps(nextProps) {
    if (this._componentWillReceiveProps) {
      this._componentWillReceiveProps(nextProps);
    }
  }

  componentWillUnmount() {
    if (this._componentWillUnmount) {
      this._componentWillUnmount();
    }
  }

  render() {
    if (this._render) {
      return this._render();
    }
    return null;
  }


  isUserLogin() {
    let user = Storage.getStorage('user');
    if (!user) {
      this.interval = setInterval(() => {
        user = Storage.getStorage('user');
        if (user) {
          this.handleUserService();
          clearInterval(this.interval)
        }
      }, 500);
    } else {
      this.handleUserService();
    }
  }




  /**
   * 新增
   */
  onAdd = () => {
    this.setState({
      record: null,
      visible: true
    });
  };

  /**
   * 修改
   * @param {object} 表单记录
   */
  onUpdate = record => {
    this.setState({
      record,
      visible: true
    });
  };

  /**
   * 删除
   * @param {object | array} 表单记录, 批量删除时为数组
   */
  onDelete = record => {
    if (!record) return;
    if ($$.isArray(record) && !record.length) return;

    const content = `您是否要删除这${
      $$.isArray(record) ? record.length : ''
      }项？`;

    Modal.confirm({
      title: '注意',
      content,
      onOk: () => {
        this.handleDelete($$.isArray(record) ? record : [record]);
      },
      onCancel() { }
    });
  };

  handleAdd() {
    /* 子类重写 */
  }
  handleUpdate() {
    /* 子类重写 */
  }
  handleDelete(records) {
    /* 子类重写 */
  }
}

export default BaseComponent;
